import { useTranslation } from 'react-i18next';
import { AllStak } from '@allstak/react';
import { useLanguage } from '@/shared/hooks/useLanguage';
import { Button, Dropdown, Avatar } from '@/shared/ui/primitives';
import { LogoutOutlined, TranslationOutlined, UserOutlined } from '@/shared/ui/icons';

export default function Topbar() {
  const { t } = useTranslation();
  const { language, setLanguage } = useLanguage();

  const handleLogout = () => {
    AllStak.addBreadcrumb('auth', 'Admin logout', 'info');
    AllStak.setUser({});
    void AllStak.flush?.(500);
    localStorage.removeItem('token');
    window.location.href = '/login';
  };

  return (
    <header className="ds-topbar">
      <Dropdown
        trigger={['click']}
        placement="bottomRight"
        menu={{
          items: [
            { key: 'en', label: 'English', disabled: language === 'en', onClick: () => setLanguage('en') },
            { key: 'ar', label: 'العربية', disabled: language === 'ar', onClick: () => setLanguage('ar') },
          ],
        }}
      >
        <Button type="text" icon={<TranslationOutlined />}>
          {language === 'ar' ? 'العربية' : 'English'}
        </Button>
      </Dropdown>

      <Button type="text" danger icon={<LogoutOutlined />} onClick={handleLogout}>
        {t('app.logout')}
      </Button>

      <Avatar size="small" icon={<UserOutlined />} style={{ marginInlineStart: 4 }} />
    </header>
  );
}
